// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.sesp-srcbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  background: #fafafa;
  margin-bottom: 16px;
}
.sesp-srcbar__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
  margin-right: 4px;
}
.sesp-srcbar__add {
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px dashed #e7eaec;
  background: #fff;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.sesp-srcbar__add:hover {
  border-color: rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
.sesp-srcbar__add:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.sesp-srcbar__add:disabled:hover {
  border-color: #e7eaec;
  color: #676a6c;
}
.sesp-srcbar__add i {
  margin-right: 4px;
}

.sesp-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 4px 0 10px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e7eaec;
  font-size: 12px;
}
.sesp-chip.is-invitation {
  border-color: rgba(0, 173, 208, 0.35);
  background: rgba(0, 173, 208, 0.05);
}
.sesp-chip__name {
  color: #6d6e71;
  font-weight: 600;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sesp-chip__count {
  background: #f1f1f2;
  color: #676a6c;
  border-radius: 8px;
  padding: 1px 6px;
  font-size: 10.5px;
  font-weight: 700;
}
.sesp-chip__x {
  border: 0;
  background: transparent;
  color: #676a6c;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  border-radius: 50%;
}
.sesp-chip__x:hover {
  color: rgb(245, 67, 89);
}

.sesp-add {
  position: relative;
}
.sesp-add__panel {
  position: absolute;
  z-index: 20;
  top: calc(100% + 6px);
  left: 0;
  width: 300px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sesp-add__group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sesp-add__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
}
.sesp-add__none {
  font-size: 12px;
  color: #676a6c;
  font-style: italic;
}
.sesp-add__close {
  align-self: flex-end;
  border: 0;
  background: transparent;
  color: rgb(105, 190, 40);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 4px;
}
.sesp-add__close:hover {
  text-decoration: underline;
}

.sesp-empty {
  text-align: center;
  padding: 48px 0;
  color: #676a6c;
  border: 1px dashed #e7eaec;
  border-radius: 8px;
}
.sesp-empty i {
  font-size: 30px;
  display: block;
  margin-bottom: 10px;
  opacity: 0.5;
}
.sesp-empty p {
  margin: 0;
  font-size: 13px;
}

.sesp-body {
  display: grid;
  grid-template-columns: 1fr 260px;
  gap: 18px;
  align-items: start;
}

.sesp-pool {
  min-width: 0;
}

.sesp-pool__bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.sesp-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  flex: 1;
  min-width: 0;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  padding: 0 10px;
}
.sesp-search i {
  color: #676a6c;
  font-size: 12px;
}
.sesp-search input {
  border: 0;
  outline: 0;
  font-size: 13px;
  flex: 1;
  min-width: 0;
  color: #676a6c;
}

.sesp-toggle {
  display: flex;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.sesp-toggle button {
  border: 0;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  padding: 0 12px;
  height: 32px;
  color: #676a6c;
  cursor: pointer;
  white-space: nowrap;
}
.sesp-toggle button.is-active {
  background: rgb(105, 190, 40);
  color: #fff;
}
.sesp-toggle button + button {
  border-left: 1px solid #e7eaec;
}

.sesp-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.sesp-filters__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
}
.sesp-filters__clear, .sesp-filters__all {
  border: 0;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #676a6c;
  padding: 0 6px;
}
.sesp-filters__clear:hover, .sesp-filters__all:hover {
  color: rgb(105, 190, 40);
  text-decoration: underline;
}
.sesp-filters__all {
  margin-left: auto;
}

.sesp-fchip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  padding: 0 9px;
  border-radius: 13px;
  border: 1px solid #e7eaec;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #676a6c;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.sesp-fchip__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
}
.sesp-fchip__dot.is-cl {
  background: rgb(0, 173, 208);
}
.sesp-fchip__dot.is-id {
  background: rgb(255, 121, 0);
}
.sesp-fchip__dot.is-dv {
  background: rgb(105, 190, 40);
}
.sesp-fchip__dot.is-im {
  background: rgb(245, 67, 89);
}
.sesp-fchip__n {
  font-weight: 700;
  color: #6d6e71;
}
.sesp-fchip:hover {
  border-color: #676a6c;
}
.sesp-fchip.is-on {
  color: #fff;
  border-color: transparent;
  font-weight: 600;
}
.sesp-fchip.is-on .sesp-fchip__n {
  color: #fff;
}
.sesp-fchip.is-on .sesp-fchip__dot {
  background: #fff;
}
.sesp-fchip.is-on.is-cl {
  background: rgb(0, 173, 208);
}
.sesp-fchip.is-on.is-id {
  background: rgb(255, 121, 0);
}
.sesp-fchip.is-on.is-dv {
  background: rgb(105, 190, 40);
}
.sesp-fchip.is-on.is-im {
  background: rgb(245, 67, 89);
}

.sesp-list {
  border: 1px solid #e7eaec;
  border-radius: 8px;
  background: #fff;
  max-height: 460px;
  overflow-y: auto;
}
.sesp-list__empty {
  padding: 32px 0;
  text-align: center;
  color: #676a6c;
  font-size: 13px;
}

.sesp-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 9px 12px;
  border: 0;
  border-bottom: 1px solid #f1f1f2;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s ease;
}
.sesp-row:last-child {
  border-bottom: 0;
}
.sesp-row:hover {
  background: #fafafa;
}
.sesp-row:focus-visible {
  outline: 2px solid rgb(0, 173, 208);
  outline-offset: -2px;
}
.sesp-row__tick {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1px solid #e7eaec;
  background: #fff;
  flex-shrink: 0;
  color: #676a6c;
  font-size: 10px;
}
.sesp-row__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.sesp-row__name {
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
.sesp-row__meta {
  font-size: 11px;
  color: #676a6c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sesp-row.is-selected {
  background: #f5fbef;
}
.sesp-row.is-selected .sesp-row__tick {
  background: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
.sesp-row.is-selected:hover {
  background: #eef8e4;
}

.sesp-chip2 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.sesp-chip2__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
}
.sesp-chip2__dot.is-cl {
  background: rgb(0, 173, 208);
}
.sesp-chip2__dot.is-id {
  background: rgb(255, 121, 0);
}
.sesp-chip2__dot.is-dv {
  background: rgb(105, 190, 40);
}
.sesp-chip2__dot.is-im {
  background: rgb(245, 67, 89);
}
.sesp-chip2__label {
  font-size: 11px;
  color: #676a6c;
}

.sesp-rail {
  position: sticky;
  top: 16px;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  background: #fafafa;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.sesp-rail__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.sesp-rail__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
  display: block;
  margin-bottom: 8px;
}
.sesp-rail__head .sesp-rail__label {
  margin-bottom: 0;
}
.sesp-rail__count {
  font-size: 26px;
  font-weight: 700;
  color: #6d6e71;
  line-height: 1;
}
.sesp-rail__note {
  font-size: 10.5px;
  color: #676a6c;
  margin: 8px 0 0;
  line-height: 1.4;
}
.sesp-rail__section {
  border-top: 1px solid #e7eaec;
  padding-top: 12px;
}
.sesp-rail__section:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.sesp-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.sesp-bar__name {
  font-size: 11px;
  color: #676a6c;
  width: 58px;
  flex-shrink: 0;
}
.sesp-bar__track {
  flex: 1;
  height: 7px;
  border-radius: 4px;
  background: #e9e9ea;
  overflow: hidden;
}
.sesp-bar__fill {
  display: block;
  height: 100%;
  border-radius: 4px;
  transition: width 0.25s ease;
}
.sesp-bar__fill.is-cl {
  background: rgb(0, 173, 208);
}
.sesp-bar__fill.is-id {
  background: rgb(255, 121, 0);
}
.sesp-bar__fill.is-dv {
  background: rgb(105, 190, 40);
}
.sesp-bar__fill.is-im {
  background: rgb(245, 67, 89);
}
.sesp-bar__n {
  font-size: 11px;
  font-weight: 700;
  color: #6d6e71;
  width: 16px;
  text-align: right;
}

.sesp-warn {
  display: flex;
  gap: 8px;
  font-size: 11.5px;
  line-height: 1.45;
  border-radius: 6px;
  padding: 9px 10px;
  background: #fff4e5;
  color: #8a5a00;
}
.sesp-warn i {
  margin-top: 1px;
}

.sesp-byorg {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  margin-bottom: 4px;
}
.sesp-byorg__name {
  color: #676a6c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sesp-byorg__n {
  font-weight: 700;
  color: #6d6e71;
  flex-shrink: 0;
}

@media (max-width: 991px) {
  .sesp-body {
    grid-template-columns: 1fr;
  }
  .sesp-rail {
    position: static;
  }
}
@media (max-width: 640px) {
  .sesp-pool__bar {
    flex-direction: column;
    align-items: stretch;
  }
  .sesp-filters__all {
    margin-left: 0;
  }
  .sesp-add__panel {
    width: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/sessions/wizard/steps/step-session-participants.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACE,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,QAAA;EACrD,kBAAA;EAAoB,yBAAA;EAAiC,kBAAA;EAAoB,mBAAA;EACzE,mBAAA;AAmZF;AAlZE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAChE,cDyBiB;ECzBG,iBAAA;AAwZxB;AAtZE;EACE,YAAA;EAAc,eAAA;EAAiB,kBAAA;EAAoB,0BAAA;EACnD,gBAAA;EAAkB,cDqBD;ECrBqB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA+Z7E;AA9ZI;EAAU,+BDQE;ECR4B,wBDQ5B;AC0ZhB;AAjaI;EAAa,YAAA;EAAc,mBAAA;AAqa/B;AAraoD;EAAU,qBDiC/C;ECjC4E,cDmBtE;ACsZrB;AAxaI;EAAI,iBAAA;AA2aR;;AAvaA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,qBAAA;EACnE,mBAAA;EAAqB,gBAAA;EAAkB,yBAAA;EAAiC,eAAA;AAib1E;AA9aE;EAAkB,qCAAA;EAA0C,mCAAA;AAkb9D;AAjbE;EAAU,cDaS;ECbmB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;EACxE,uBAAA;EAAyB,mBAAA;AAwb7B;AAvbE;EACE,mBAAA;EAAqB,cDKJ;ECLwB,kBAAA;EAAoB,gBAAA;EAC7D,iBAAA;EAAmB,gBAAA;AA6bvB;AA3bE;EACE,SAAA;EAAW,uBAAA;EAAyB,cDCnB;ECDuC,eAAA;EAAiB,gBAAA;EACzE,cAAA;EAAgB,kBAAA;AAkcpB;AAjcI;EAAU,uBDZI;ACgdlB;;AA/bA;EACE,kBAAA;AAkcF;AAjcE;EACE,kBAAA;EAAoB,WAAA;EAAa,qBAAA;EAAuB,OAAA;EAAS,YAAA;EACjE,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EACnD,0CAAA;EAA4C,aAAA;EAC5C,aAAA;EAAe,sBAAA;EAAwB,SAAA;AA4c3C;AA1cE;EAAW,aAAA;EAAe,sBAAA;EAAwB,QAAA;AA+cpD;AA9cE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAChE,cDjBiB;ACoerB;AAjdE;EAAU,eAAA;EAAiB,cDnBR;ECmB4B,kBAAA;AAsdjD;AArdE;EACE,oBAAA;EAAsB,SAAA;EAAW,uBAAA;EAAyB,wBDjC9C;ECkCZ,eAAA;EAAiB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AA6dxD;AA5dI;EAAU,0BAAA;AA+dd;;AA3dA;EACE,kBAAA;EAAoB,eAAA;EAAiB,cD5BlB;EC6BnB,0BAAA;EAAkC,kBAAA;AAiepC;AAheE;EAAI,eAAA;EAAiB,cAAA;EAAgB,mBAAA;EAAqB,YAAA;AAse5D;AAreE;EAAI,SAAA;EAAW,eAAA;AAyejB;;AAreA;EAAa,aAAA;EAAe,gCAAA;EAAkC,SAAA;EAAW,kBAAA;AA4ezE;;AA1eA;EAAa,YAAA;AA8eb;;AA7eA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,mBAAA;AAofjE;;AAlfA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,OAAA;EAAS,YAAA;EACrE,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;AA6fzE;AA5fE;EAAI,cD3Ce;EC2CK,eAAA;AAggB1B;AA/fE;EAAQ,SAAA;EAAW,UAAA;EAAY,eAAA;EAAiB,OAAA;EAAS,YAAA;EAAc,cD5CpD;ACmjBrB;;AApgBA;EACE,aAAA;EAAe,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;AA2gBxF;AA1gBE;EACE,SAAA;EAAW,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;EAAiB,YAAA;EACxF,cDnDiB;ECmDG,eAAA;EAAiB,mBAAA;AAmhBzC;AAlhBI;EAAc,6BDhEF;ECgE8B,WAAA;AAshB9C;AAphBE;EAAkB,8BAAA;AAuhBpB;;AAnhBA;EACE,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,QAAA;EAAU,mBAAA;AA0hBjE;AAzhBE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAChE,cD9DiB;AC4lBrB;AA5hBE;EACE,SAAA;EAAW,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;EACvE,cDlEiB;ECkEG,cAAA;AAmiBxB;AAliBI;EAAU,wBD/EE;EC+EqB,0BAAA;AAsiBrC;AApiBE;EAAS,iBAAA;AAuiBX;;AApiBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,cAAA;EACnE,mBAAA;EAAqB,yBAAA;EAAiC,gBAAA;EAAkB,eAAA;EACxE,eAAA;EAAiB,cD3EE;EC2EkB,wDAAA;AAgjBvC;AA/iBE;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,qBAAA;AAojBjD;AAnjBI;EAAU,4BD5FE;ACkpBhB;AAtjB4C;EAAU,4BD3FvC;ACopBf;AAxjBI;EAAU,6BD3FE;ACspBhB;AA3jB4C;EAAU,4BD1FpC;ACwpBlB;AA5jBE;EAAO,gBAAA;EAAkB,cD5EN;AC4oBrB;AA/jBE;EAAU,qBDlFS;ACopBrB;AAhkBE;EAAU,WAAA;EAAa,yBAAA;EAA2B,gBAAA;AAqkBpD;AApkBI;EAAiB,WAAA;AAukBrB;AAtkBI;EAAmB,gBAAA;AAykBvB;AAxkBI;EAAU,4BDrGE;ACgrBhB;AA3kB4C;EAAU,4BDpGvC;ACkrBf;AA7kBI;EAAU,6BDpGE;ACorBhB;AAhlB4C;EAAU,4BDnGpC;ACsrBlB;;AA9kBA;EACE,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACrD,iBAAA;EAAmB,gBAAA;AAolBrB;AAnlBE;EAAW,eAAA;EAAiB,kBAAA;EAAoB,cDhG7B;ECgGiD,eAAA;AAylBtE;;AAtlBA;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAAa,gBAAA;EAC5D,iBAAA;EAAmB,SAAA;EAAW,gCAAA;EAAkC,uBAAA;EAChE,eAAA;EAAiB,iCAAA;AAimBnB;AAhmBE;EAAe,gBAAA;AAmmBjB;AAlmBE;EAAU,mBAAA;AAqmBZ;AApmBE;EAAkB,mCAAA;EAAmC,oBAAA;AAwmBvD;AAvmBE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EACjF,kBAAA;EAAoB,yBAAA;EAAiC,gBAAA;EAAkB,cAAA;EACvE,cD7GiB;EC6GG,eAAA;AAinBxB;AA/mBE;EAAU,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAc,OAAA;AAqnBjE;AApnBE;EAAU,eAAA;EAAiB,gBAAA;EAAkB,cD3G1B;ACouBrB;AAxnBE;EACE,eAAA;EAAiB,cDlHA;ECkHoB,gBAAA;EAAkB,uBAAA;EACvD,mBAAA;AA6nBJ;AA3nBE;EACE,mBAAA;AA6nBJ;AA5nBI;EAAkB,6BDnIN;ECmIkC,+BDnIlC;ECmIgE,WAAA;AAioBhF;AAhoBI;EAAU,mBAAA;AAmoBd;;AA7nBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,cAAA;AAmoBvD;AAloBE;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,qBAAA;AAuoBjD;AAtoBI;EAAU,4BDhJE;ACyxBhB;AAzoB4C;EAAU,4BD/IvC;AC2xBf;AA3oBI;EAAU,6BD/IE;AC6xBhB;AA9oB4C;EAAU,4BD9IpC;AC+xBlB;AA/oBE;EAAW,eAAA;EAAiB,cDrIT;ACwxBrB;;AA/oBA;EACE,gBAAA;EAAkB,SAAA;EAClB,yBAAA;EAAiC,kBAAA;EAAoB,mBAAA;EAAqB,aAAA;EAC1E,aAAA;EAAe,sBAAA;EAAwB,SAAA;AAwpBzC;AAvpBE;EAAU,aAAA;EAAe,qBAAA;EAAuB,8BAAA;AA4pBlD;AA3pBE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAChE,cDhJiB;ECgJG,cAAA;EAAgB,kBAAA;AAkqBxC;AAhqBE;EAAmB,gBAAA;AAmqBrB;AAlqBE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cD9I3B;EC8IuD,cAAA;AAwqB5E;AAvqBE;EAAU,iBAAA;EAAmB,cDpJV;ECoJ8B,eAAA;EAAiB,gBAAA;AA6qBpE;AA5qBE;EAAa,6BAAA;EAAqC,iBAAA;AAgrBpD;AA/qBE;EAA2B,aAAA;EAAe,cAAA;AAmrB5C;;AAhrBA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,kBAAA;AAsrBhD;AArrBE;EAAU,eAAA;EAAiB,cD3JR;EC2J4B,WAAA;EAAa,cAAA;AA2rB9D;AA1rBE;EAAW,OAAA;EAAS,WAAA;EAAa,kBAAA;EAAoB,mBAAA;EAAqB,gBAAA;AAisB5E;AAhsBE;EACE,cAAA;EAAgB,YAAA;EAAc,kBAAA;EAAoB,4BAAA;AAqsBtD;AApsBI;EAAU,4BD7KE;ACo3BhB;AAvsB4C;EAAU,4BD5KvC;ACs3Bf;AAzsBI;EAAU,6BD5KE;ACw3BhB;AA5sB4C;EAAU,4BD3KpC;AC03BlB;AA7sBE;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cD7JvB;EC6JmD,WAAA;EAAa,iBAAA;AAotBrF;;AAjtBA;EACE,aAAA;EAAe,QAAA;EAAU,iBAAA;EAAmB,iBAAA;EAAmB,kBAAA;EAAoB,iBAAA;EACnF,mBAAA;EAAqB,cAAA;AA0tBvB;AAztBE;EAAI,eAAA;AA4tBN;;AAztBA;EACE,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,eAAA;EAAiB,kBAAA;AAguB5E;AA/tBE;EAAU,cD7KS;EC6KW,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAquB3E;AApuBE;EAAO,gBAAA;EAAkB,cDzKN;ECyKkC,cAAA;AAyuBvD;;AAtuBA;EACE;IAAa,0BAAA;EA0uBb;EAzuBA;IAAa,gBAAA;EA4uBb;AACF;AA3uBA;EACE;IAAkB,sBAAA;IAAwB,oBAAA;EA+uB1C;EA9uBA;IAAqB,cAAA;EAivBrB;EAhvBA;IAAmB,YAAA;EAmvBnB;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../../assets/styles/variables\";\n\n// $color-neutral-mid is #ccc — a hairline grey, ~1.6:1 on white. Muted TEXT uses this instead.\n$sesp-muted: $body-content-color;\n\n.sesp-srcbar {\n  display: flex; align-items: center; flex-wrap: wrap; gap: 8px;\n  padding: 12px 14px; border: 1px solid $color-grey-1; border-radius: 8px; background: #fafafa;\n  margin-bottom: 16px;\n  &__label {\n    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;\n    color: $sesp-muted; margin-right: 4px;\n  }\n  &__add {\n    height: 28px; padding: 0 10px; border-radius: 6px; border: 1px dashed $color-grey-1;\n    background: #fff; color: $sesp-muted; font-size: 12px; font-weight: 600; cursor: pointer;\n    &:hover { border-color: $develop-color; color: $develop-color; }\n    &:disabled { opacity: 0.5; cursor: not-allowed; &:hover { border-color: $color-grey-1; color: $sesp-muted; } }\n    i { margin-right: 4px; }\n  }\n}\n\n.sesp-chip {\n  display: inline-flex; align-items: center; gap: 6px; height: 28px; padding: 0 4px 0 10px;\n  border-radius: 14px; background: #fff; border: 1px solid $color-grey-1; font-size: 12px;\n  // Org chips read neutral; invitation chips get a faint accent tint so the mixed bar is scannable\n  // at a glance without relying on the label text alone.\n  &.is-invitation { border-color: rgba($clarify-color, 0.35); background: rgba($clarify-color, 0.05); }\n  &__name { color: $color-neutral-dark; font-weight: 600; max-width: 220px; overflow: hidden;\n    text-overflow: ellipsis; white-space: nowrap; }\n  &__count {\n    background: #f1f1f2; color: $sesp-muted; border-radius: 8px; padding: 1px 6px;\n    font-size: 10.5px; font-weight: 700;\n  }\n  &__x {\n    border: 0; background: transparent; color: $sesp-muted; cursor: pointer; padding: 2px 4px;\n    line-height: 1; border-radius: 50%;\n    &:hover { color: $implement-color; }\n  }\n}\n\n// ── The mixed add control ───────────────────────\n.sesp-add {\n  position: relative;\n  &__panel {\n    position: absolute; z-index: 20; top: calc(100% + 6px); left: 0; width: 300px;\n    background: #fff; border: 1px solid $color-grey-1; border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12); padding: 12px;\n    display: flex; flex-direction: column; gap: 12px;\n  }\n  &__group { display: flex; flex-direction: column; gap: 6px; }\n  &__label {\n    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;\n    color: $sesp-muted;\n  }\n  &__none { font-size: 12px; color: $sesp-muted; font-style: italic; }\n  &__close {\n    align-self: flex-end; border: 0; background: transparent; color: $develop-color;\n    font-size: 12px; font-weight: 600; cursor: pointer; padding: 2px 4px;\n    &:hover { text-decoration: underline; }\n  }\n}\n\n.sesp-empty {\n  text-align: center; padding: 48px 0; color: $sesp-muted;\n  border: 1px dashed $color-grey-1; border-radius: 8px;\n  i { font-size: 30px; display: block; margin-bottom: 10px; opacity: 0.5; }\n  p { margin: 0; font-size: 13px; }\n}\n\n// ── Two-column body ───────────────────────\n.sesp-body { display: grid; grid-template-columns: 1fr 260px; gap: 18px; align-items: start; }\n\n.sesp-pool { min-width: 0; }\n.sesp-pool__bar { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }\n\n.sesp-search {\n  display: flex; align-items: center; gap: 8px; height: 32px; flex: 1; min-width: 0;\n  border: 1px solid $color-grey-1; border-radius: 6px; background: #fff; padding: 0 10px;\n  i { color: $sesp-muted; font-size: 12px; }\n  input { border: 0; outline: 0; font-size: 13px; flex: 1; min-width: 0; color: $body-content-color; }\n}\n\n.sesp-toggle {\n  display: flex; border: 1px solid $color-grey-1; border-radius: 6px; overflow: hidden; background: #fff;\n  button {\n    border: 0; background: transparent; font-size: 12px; font-weight: 600; padding: 0 12px; height: 32px;\n    color: $sesp-muted; cursor: pointer; white-space: nowrap;\n    &.is-active { background: $develop-color; color: #fff; }\n  }\n  button + button { border-left: 1px solid $color-grey-1; }\n}\n\n// ── Peak filters ───────────────────────\n.sesp-filters {\n  display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-bottom: 10px;\n  &__label {\n    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;\n    color: $sesp-muted;\n  }\n  &__clear, &__all {\n    border: 0; background: transparent; font-size: 12px; font-weight: 600; cursor: pointer;\n    color: $sesp-muted; padding: 0 6px;\n    &:hover { color: $develop-color; text-decoration: underline; }\n  }\n  &__all { margin-left: auto; }\n}\n\n.sesp-fchip {\n  display: inline-flex; align-items: center; gap: 5px; height: 26px; padding: 0 9px;\n  border-radius: 13px; border: 1px solid $color-grey-1; background: #fff; cursor: pointer;\n  font-size: 12px; color: $sesp-muted; transition: border-color 0.2s ease, background 0.2s ease;\n  &__dot {\n    width: 7px; height: 7px; border-radius: 50%; display: inline-block;\n    &.is-cl { background: $clarify-color; } &.is-id { background: $ideate-color; }\n    &.is-dv { background: $develop-color; } &.is-im { background: $implement-color; }\n  }\n  &__n { font-weight: 700; color: $color-neutral-dark; }\n  &:hover { border-color: $sesp-muted; }\n  // The chip's own preference colours it when on — never colour alone: aria-pressed carries it too.\n  &.is-on { color: #fff; border-color: transparent; font-weight: 600;\n    .sesp-fchip__n { color: #fff; }\n    .sesp-fchip__dot { background: #fff; }\n    &.is-cl { background: $clarify-color; } &.is-id { background: $ideate-color; }\n    &.is-dv { background: $develop-color; } &.is-im { background: $implement-color; }\n  }\n}\n\n// ── The list ───────────────────────\n.sesp-list {\n  border: 1px solid $color-grey-1; border-radius: 8px; background: #fff;\n  max-height: 460px; overflow-y: auto;\n  &__empty { padding: 32px 0; text-align: center; color: $sesp-muted; font-size: 13px; }\n}\n\n.sesp-row {\n  display: flex; align-items: center; gap: 10px; width: 100%; text-align: left;\n  padding: 9px 12px; border: 0; border-bottom: 1px solid #f1f1f2; background: transparent;\n  cursor: pointer; transition: background 0.15s ease;\n  &:last-child { border-bottom: 0; }\n  &:hover { background: #fafafa; }\n  &:focus-visible { outline: 2px solid $clarify-color; outline-offset: -2px; }\n  &__tick {\n    display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px;\n    border-radius: 6px; border: 1px solid $color-grey-1; background: #fff; flex-shrink: 0;\n    color: $sesp-muted; font-size: 10px;\n  }\n  &__body { display: flex; flex-direction: column; min-width: 0; flex: 1; }\n  &__name { font-size: 13px; font-weight: 600; color: $color-neutral-dark; }\n  &__meta {\n    font-size: 11px; color: $sesp-muted; overflow: hidden; text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  &.is-selected {\n    background: #f5fbef;\n    .sesp-row__tick { background: $develop-color; border-color: $develop-color; color: #fff; }\n    &:hover { background: #eef8e4; }\n  }\n}\n\n// The peak chip — same fact as the session board's invs-chip, its own class so this component\n// doesn't leak invs-/inv- classes into the global stylesheet.\n.sesp-chip2 {\n  display: inline-flex; align-items: center; gap: 4px; flex-shrink: 0;\n  &__dot {\n    width: 7px; height: 7px; border-radius: 50%; display: inline-block;\n    &.is-cl { background: $clarify-color; } &.is-id { background: $ideate-color; }\n    &.is-dv { background: $develop-color; } &.is-im { background: $implement-color; }\n  }\n  &__label { font-size: 11px; color: $sesp-muted; }\n}\n\n// ── The rail ───────────────────────\n.sesp-rail {\n  position: sticky; top: 16px;\n  border: 1px solid $color-grey-1; border-radius: 8px; background: #fafafa; padding: 14px;\n  display: flex; flex-direction: column; gap: 14px;\n  &__head { display: flex; align-items: baseline; justify-content: space-between; }\n  &__label {\n    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;\n    color: $sesp-muted; display: block; margin-bottom: 8px;\n  }\n  &__head &__label { margin-bottom: 0; }\n  &__count { font-size: 26px; font-weight: 700; color: $color-neutral-dark; line-height: 1; }\n  &__note { font-size: 10.5px; color: $sesp-muted; margin: 8px 0 0; line-height: 1.4; }\n  &__section { border-top: 1px solid $color-grey-1; padding-top: 12px; }\n  &__section:first-of-type { border-top: 0; padding-top: 0; }\n}\n\n.sesp-bar {\n  display: flex; align-items: center; gap: 8px; margin-bottom: 6px;\n  &__name { font-size: 11px; color: $sesp-muted; width: 58px; flex-shrink: 0; }\n  &__track { flex: 1; height: 7px; border-radius: 4px; background: #e9e9ea; overflow: hidden; }\n  &__fill {\n    display: block; height: 100%; border-radius: 4px; transition: width 0.25s ease;\n    &.is-cl { background: $clarify-color; } &.is-id { background: $ideate-color; }\n    &.is-dv { background: $develop-color; } &.is-im { background: $implement-color; }\n  }\n  &__n { font-size: 11px; font-weight: 700; color: $color-neutral-dark; width: 16px; text-align: right; }\n}\n\n.sesp-warn {\n  display: flex; gap: 8px; font-size: 11.5px; line-height: 1.45; border-radius: 6px; padding: 9px 10px;\n  background: #fff4e5; color: #8a5a00;\n  i { margin-top: 1px; }\n}\n\n.sesp-byorg {\n  display: flex; justify-content: space-between; gap: 8px; font-size: 12px; margin-bottom: 4px;\n  &__name { color: $sesp-muted; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  &__n { font-weight: 700; color: $color-neutral-dark; flex-shrink: 0; }\n}\n\n@media (max-width: 991px) {\n  .sesp-body { grid-template-columns: 1fr; }\n  .sesp-rail { position: static; }\n}\n@media (max-width: 640px) {\n  .sesp-pool__bar { flex-direction: column; align-items: stretch; }\n  .sesp-filters__all { margin-left: 0; }\n  .sesp-add__panel { width: 260px; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
